"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("../../shared-types/enums");
exports.requestSchema = zod_1.z.object({
    language: enums_1.languageEnum.optional().nullable(),
    smsNumber: zod_1.z.string().optional().nullable(),
    depth: zod_1.z.string().optional().nullable(),
    fertigation: zod_1.z.string().optional().nullable(),
    speed: zod_1.z.string().optional().nullable(),
    rain: zod_1.z.string().optional().nullable(),
    temperature: zod_1.z.string().optional().nullable(),
    pressure: zod_1.z.string().optional().nullable(),
    flowRate: zod_1.z.string().optional().nullable(),
    volume: zod_1.z.string().optional().nullable(),
    showDataSource: zod_1.z.boolean().optional().nullable(),
    showRegionalData: zod_1.z.boolean().optional().nullable(),
});
exports.path = '/update-user-profile';
//# sourceMappingURL=index.js.map